module.exports = __webpack_public_path__ + "public/images/gaming.2ecd28feddd63c8edfb437db0b89fe52.png";